export default import.meta.ROLLUP_FILE_URL_GPv6qhlM;